import {
    autocompleteFieldConstructor,
    dropdownFieldConfigConstructor, numberFieldConstructor, rangeFieldConfigConstructor, switchFieldConstructor,
    switchWithAutoCompleteFieldConfigConstructor
} from "scenes/cohort-filters/filter-configs/fieldContructors";
import {Category} from "scenes/cohort-filters/filter-configs/categories";
import {nestedFieldConstructor} from "scenes/cohort-filters/filter-configs/fieldContructors/nestedField";

export const cancerFields = {
    ...switchWithAutoCompleteFieldConfigConstructor({
        category: Category.CANCER,
        pathToSelectValues: "anamnesis.activeCancerData.values.value",
        pathToSwitchQuestion: "anamnesis.activeCancer",
        autocompleteLabel: "anamnesis.cancer.which-cancer",
        fieldLabel: "anamnesis.cancer.activeCancer",
    }),
    ...switchWithAutoCompleteFieldConfigConstructor({
        category: Category.CANCER,
        pathToSelectValues: "anamnesis.pastCancerData.values.value",
        pathToSwitchQuestion: "anamnesis.pastCancer",
        autocompleteLabel: "anamnesis.cancer.which-cancer",
        fieldLabel: "anamnesis.cancer.pastCancer",
    }),
    ...switchWithAutoCompleteFieldConfigConstructor({
        category: Category.CANCER,
        pathToSelectValues: "anamnesis.pastCancerData.values.value",
        pathToSwitchQuestion: "anamnesis.pastCancer",
        autocompleteLabel: "anamnesis.cancer.which-cancer",
        fieldLabel: "anamnesis.cancer.pastCancer",
    }),
    ...nestedFieldConstructor({
        category: Category.CANCER,
        label: "anamnesis.cancer.familyCancer",
        nestedPath: "anamnesis.familyCancerData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedFamilyCancer$anamnesis.familyCancer",
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "anamnesis.familyCancerData.values.who",
                label: "global.grade-of-family",
                nestedComponent: true,
                dropdownValues: Object.freeze([
                    "GRANDPARENT",
                    "PARENT",
                    "SIBLING",
                    "CHILDREN"
                ]),
                fieldWidth: 150,
            }),
            autocompleteFieldConstructor({
                pathToValue: "anamnesis.familyCancerData.values.kind",
                label: "anamnesis.cancer.which-cancer",
                fieldWidth: 150,
                nestedComponent: true,
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "anamnesis.familyCancerData.values.when",
                label: "global.at-age",
                nestedComponent: true,
                dropdownValues: Object.freeze([
                    "<30",
                    "30-50",
                    "50-70",
                    ">70"
                ]),
                fieldWidth: 150,
            }),
        ],
    }),
    ...nestedFieldConstructor({
        category: Category.CANCER,
        label: "anamnesis.cancer.radio-activeCancer",
        nestedPath: "$1$anamnesis.activeCancerData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedActiveCancer1$anamnesis.activeCancer",
            }),
            numberFieldConstructor({
                pathToValue: "anamnesis.activeCancerData.values.radiationSessionsPerWeek",
                label: "radiationSessionsPerWeek",
                fieldWidth: 80,
                nestedComponent: true,
            }),
        ],
    }),
    ...nestedFieldConstructor({
        category: Category.CANCER,
        label: "anamnesis.cancer.radio-pastCancer",
        nestedPath: "$2$anamnesis.pastCancerData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedPastCancer2$anamnesis.pastCancer",
            }),
            numberFieldConstructor({
                pathToValue: "anamnesis.pastCancerData.values.radiationSessionsPerWeek",
                label: "radiationSessionsPerWeek",
                fieldWidth: 80,
                nestedComponent: true,
            }),
        ],
    }),
    ...nestedFieldConstructor({
        category: Category.CANCER,
        label: "anamnesis.cancer.surgery-activeCancer",
        nestedPath: "$3$anamnesis.activeCancerData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedActiveCancer3$anamnesis.activeCancer",
            }),
            rangeFieldConfigConstructor({
                nestedComponent: true,
                pathToValue: "anamnesis.activeCancerData.values.surgeryDate",
                label: "Date",
                isDate: true,
                fieldWidth: 100,
            }),
        ],
    }),
    ...nestedFieldConstructor({
        category: Category.CANCER,
        label: "anamnesis.cancer.surgery-pastCancer",
        nestedPath: "$4$anamnesis.pastCancerData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedPastCancer4$anamnesis.pastCancer",
            }),
            rangeFieldConfigConstructor({
                nestedComponent: true,
                pathToValue: "anamnesis.pastCancerData.values.surgeryDate",
                label: "Date",
                isDate: true,
                fieldWidth: 100,
            }),
        ],
    }),
    ...nestedFieldConstructor({
        category: Category.CANCER,
        label: "anamnesis.cancer.chemo-activeCancer",
        nestedPath: "$5$anamnesis.activeCancerData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedActiveCancer5$anamnesis.activeCancer",
            }),
            rangeFieldConfigConstructor({
                nestedComponent: true,
                pathToValue: "anamnesis.activeCancerData.values.chemotherapyFromDate",
                label: "Date",
                isDate: true,
                fieldWidth: 100,
            }),
            autocompleteFieldConstructor({
                pathToValue: "anamnesis.activeCancerData.values.chemoSubstance",
                label: "anamnesis.cancer.chemoSubstance",
                fieldWidth: 150,
                nestedComponent: true,
            }),
        ],
    }),
    ...nestedFieldConstructor({
        category: Category.CANCER,
        label: "anamnesis.cancer.chemo-pastCancer",
        nestedPath: "$6$anamnesis.pastCancerData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedPastCancer6$anamnesis.pastCancer",
            }),
            rangeFieldConfigConstructor({
                nestedComponent: true,
                pathToValue: "anamnesis.pastCancerData.values.chemotherapyFromDate",
                label: "Date",
                isDate: true,
                fieldWidth: 100,
            }),
            autocompleteFieldConstructor({
                pathToValue: "anamnesis.pastCancerData.values.chemoSubstance",
                label: "anamnesis.cancer.chemoSubstance",
                fieldWidth: 150,
                nestedComponent: true,
            }),
        ],
    }),
}
